// Konfiguration mit Prioritaet:
//   1. window._env_  (Laufzeit, aus env-config.js -> Container-Env, KEIN Rebuild noetig)
//   2. process.env   (Build-Zeit, von CRA einkompiliert)
//   3. hartkodierter Fallback
const runtimeEnv = (typeof window !== 'undefined' && window._env_) ? window._env_ : {};
const buildEnv = process.env;

const pick = (key, fallback) => {
    const rt = runtimeEnv[key];
    if (rt !== undefined && rt !== null && rt !== '') return rt;
    const bt = buildEnv[key];
    if (bt !== undefined && bt !== null && bt !== '') return bt;
    return fallback;
};

export const keycloakConfig = {
    "realm":    pick('REACT_APP_KEYCLOAK_REALM',     "ancorelog"),
    "url":      pick('REACT_APP_KEYCLOAK_URL',       "https://security.dmt-group.dev"),
    "clientId": pick('REACT_APP_KEYCLOAK_CLIENT_ID', "ancorelog-webapp"),
};

const apiUrl          = pick('REACT_APP_API_URL', 'http://localhost:8185');
const drillholeApiUrl = pick('REACT_APP_DRILLHOLE_API_URL', apiUrl);

const settings = {
    apiUrl: apiUrl,
    drillholeApiUrl: drillholeApiUrl,
    keycloakAuthUrl: keycloakConfig.url + '/realms/' + keycloakConfig.realm + '/protocol/openid-connect/token',
    logoutUrl: keycloakConfig.url + '/realms/' + keycloakConfig.realm + '/protocol/openid-connect/logout',
    logoutRedirect: buildEnv.NODE_ENV === 'development' ? 'http://localhost:1841/' : 'https://api.ancorelog.dmt-group.dev/',
    filePath: buildEnv.NODE_ENV === 'development' ? 'http://localhost:1841/' : 'https://api.ancorelog.dmt-group.dev/',
    ooApiUrl: pick('REACT_APP_OO_API_URL', drillholeApiUrl),
}
export default settings;
